import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { LinkListBlock, PlainContentModuleContainer } from "@silvertours/front-entities";
export var SingleLinkList = function(param) {
    var badge = param.badge, heading = param.heading, list = param.list, translations = param.translations;
    if (list.links.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsx(PlainContentModuleContainer, {
        children: /*#__PURE__*/ _jsx(LinkListBlock, {
            content: _object_spread_props(_object_spread({}, list), {
                badge: badge,
                heading: heading
            }),
            translations: translations
        })
    });
};
